/**
 * UranIA PA — Dashboard widget: Tenant info (US-011 AC#1).
 *
 * Mostra il tenant attivo dell'utente derivato dal claim `tenant_id`
 * del JWT (popolato in `useAuthStore.principal.tenantId` da
 * `completeFederatedLogin`). Quando il claim manca (es. utente
 * platform_admin senza scope tenant), si rende uno stato esplicito.
 *
 * NB: in Fase 1 il widget mostra l'ULID del tenant; in Fase 2 (US-F2-*
 * profili tenant) verrà arricchito con denominazione AdG, fondo
 * principale e PO di riferimento — qui teniamo il contratto stabile.
 */

import { useTranslation } from 'react-i18next';
import type { JSX } from 'react';

import { selectPrincipal, useAuthStore } from '../../lib/auth/auth-store.ts';

export function DashboardTenantInfoWidget(): JSX.Element {
  const { t } = useTranslation();
  const principal = useAuthStore(selectPrincipal);
  const tenantId = principal?.tenantId ?? null;
  const acr = principal?.acr ?? null;

  return (
    <article
      className="urania-dashboard__widget card h-100 shadow-sm border-0"
      data-testid="dashboard-widget-tenant-info"
      aria-labelledby="urania-dashboard-tenant-info-heading"
    >
      <div className="card-body">
        <h2 id="urania-dashboard-tenant-info-heading" className="h5 card-title">
          {t('dashboard.tenant_info.title')}
        </h2>
        {tenantId !== null ? (
          <dl className="urania-dashboard__widget-body mb-0">
            <dt className="small text-muted">{t('dashboard.tenant_info.label_tenant_id')}</dt>
            <dd className="mb-2">
              <code data-testid="dashboard-widget-tenant-info-id">{tenantId}</code>
            </dd>
            <dt className="small text-muted">{t('dashboard.tenant_info.label_acr')}</dt>
            <dd className="mb-0">
              <code data-testid="dashboard-widget-tenant-info-acr">{acr ?? '—'}</code>
            </dd>
          </dl>
        ) : (
          <p className="text-muted mb-0" data-testid="dashboard-widget-tenant-info-empty">
            {t('dashboard.tenant_info.empty')}
          </p>
        )}
      </div>
    </article>
  );
}
